//
//  Tile is used to for cart items and order items on checkout and checkout summary views
//
import { Component, ChangeDetectionStrategy, OnInit, Input, ChangeDetectorRef } from '@angular/core';

import * as State from '@shared/state';
import { Controllers } from '@shared/core/controllers';

import { TilesComponent } from '../../tiles.shared.component';

import { Observable } from 'rxjs';
import { IOrder } from '@shared/state';

@Component({
    selector: 'shared-tile-for-order-type',
    templateUrl: './tile-for-order-type.shared.component.html',
    styleUrls: ['./tile-for-order-type.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TileForOrderTypeComponent extends TilesComponent implements OnInit {
    @Input() public orderType: IOrder;

    public image$: Observable<State.IOrderTypeImage>;

    constructor(
        public changeDetectorRef: ChangeDetectorRef,
        public controllers: Controllers,
    ) {
        super(changeDetectorRef, controllers);
    }

    ngOnInit(): void {
        if (this.orderType) {
            this.image$ = this.controllers.images.imageForOrderType$(this.orderType.Id);
        }
    }
}
